import { render, staticRenderFns } from "./ModalNotas.vue?vue&type=template&id=aa2fb582&lang=pug&"
import script from "./ModalNotas.vue?vue&type=script&lang=js&"
export * from "./ModalNotas.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotas.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports